import {
  PackagePickerEssentialsProvider,
  SiteAuthorizationType,
  getSearchParams,
  HeaderFooterProvider,
} from '@wix/package-picker-shared';
import { Trans } from '@wix/wix-i18n-config';
import React from 'react';
import { EclipsePackagePickerModule } from '../modules/eclipse-package-picker.module';

const SENTRY_DSN =
  'https://88dea3ee13cd912db5a5b5a06f57499d@o37417.ingest.us.sentry.io/4511254259761152';

export type EclipseApplicationProps = {
  siteGuid?: string;
  basename: string;
  locale: string;
  userId?: string;
  clientId?: string;
  siteAuthorizationType?: SiteAuthorizationType;
};

export const EclipseApplication = ({
  basename,
  userId,
  siteGuid,
  locale,
  clientId,
  siteAuthorizationType,
}: EclipseApplicationProps) => {
  const { flow } = getSearchParams();
  const isAnonymous = !userId;

  React.useEffect(() => {
    HeaderFooterProvider({ locale, isAnonymous });
  }, []);

  return (
    <PackagePickerEssentialsProvider
      artifactId="package-picker-eclipse"
      version="1.0.0"
      Trans={Trans}
      sentryDsn={SENTRY_DSN}
      userId={userId}
      basename={basename ?? ''}
      siteGuid={siteGuid}
      locale={locale}
    >
      <EclipsePackagePickerModule.Provider
        translations={{ Loading: <></> }}
        context={{
          basename,
          userId,
          locale,
          siteGuid,
          clientId,
          siteAuthorizationType,
          ...(flow && { purchaseContextOverride: { params: { flow } } }),
        }}
      >
        <EclipsePackagePickerModule.SDK.Application />
      </EclipsePackagePickerModule.Provider>
    </PackagePickerEssentialsProvider>
  );
};
